<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="fillet">
      <div class="retrieval">
        <!-- 表头设置控件 -->
        <div class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`车辆行驶里程详情`)">导出</el-button>
        </div>
      </div>
    </div>

    <!-- <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
    </SearchField> -->

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      formInline: {},
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "行驶里程详情" },
      ],
      baseUrl: 'car',
      getListUrl: 'getmileage',
      // formInline: {
      //   status: 1,
      // },
      // formCtrl: [
      //   {
      //     ...this.ctrls.license,
      //   },
      // ],
      cols: [
        { keyName: "month", label: "月份", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        // { keyName: "trailer", label: "挂车号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名" },
        // { keyName: "escort", label: "押运员" },
        { keyName: "mileage", label: "里程", minwidth: 120 },
      ],
      baseParams: ['license'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    setParams() {
      const { license } = this.$route.query
      // console.log(this.$route)
      // console.log(license)
      this.formInline.license = license
      // console.log({...this.formInline})
      this.getList()
    },
  },
  mounted() {
    this.page = 1
    this.formInline = {}
    // console.log({...this.formInline})
    this.$nextTick(this.setParams)
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form--inline .el-form-item:nth-last-child(3) {
  margin-right: 20px;
}
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 0 0 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .retrieval {
    height: 52px;
    /* overflow: hidden; */
    // margin: 0px 20px;
    font-size: 14px;
    color: #606266;
    // display: flex;
    // justify-content: space-between;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
    }
  }
}
</style>